import { useEffect, useState } from 'react'
import { useWindowSize } from 'usehooks-ts'

const defaultBreakpoints: { [key in Breakpoint]: number } = {
  xs: 576,
  sm: 768,
  md: 1024,
  lg: 1440
}

function useBreakpoint(customBreakpoints?: {
  [key in Breakpoint]: number
}): Breakpoint {
  const breakpoints = customBreakpoints || defaultBreakpoints
  const windowSize = useWindowSize()
  const [currentBreakpoint, setCurrentBreakpoint] =
    useState<Breakpoint>('xs')

  useEffect(() => {
    const findCurrentBreakpoint = () => {
      const keys = Object.keys(breakpoints) as Breakpoint[]
      keys.reverse()

      let newBreakpoint: Maybe<Breakpoint> = null
      for (const breakpoint of keys) {
        if (
          windowSize.width >=
          breakpoints[breakpoint as keyof typeof breakpoints]
        ) {
          newBreakpoint = breakpoint
          break
        }
      }

      if (!newBreakpoint) {
        newBreakpoint = 'sm'
      }

      setCurrentBreakpoint(newBreakpoint)
    }

    findCurrentBreakpoint()

    // Re-run the breakpoint check when the window size changes
    window.addEventListener('resize', findCurrentBreakpoint)

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener('resize', findCurrentBreakpoint)
    }
  }, [windowSize.width, breakpoints])

  return currentBreakpoint
}

export default useBreakpoint


export function breakpointGTE(breakpoint: Breakpoint, size: Breakpoint): boolean {
  const breakpoints = ['xs', 'sm', 'md', 'lg']
  return breakpoints.indexOf(breakpoint) >= breakpoints.indexOf(size)
}

export function breakpointLTE(breakpoint: Breakpoint, size: Breakpoint): boolean {
  const breakpoints = ['xs', 'sm', 'md', 'lg']
  return breakpoints.indexOf(breakpoint) <= breakpoints.indexOf(size)
}

export function breakpointGT(breakpoint: Breakpoint, size: Breakpoint): boolean {
  const breakpoints = ['xs', 'sm', 'md', 'lg']
  return breakpoints.indexOf(breakpoint) > breakpoints.indexOf(size)
}

export function breakpointLT(breakpoint: Breakpoint, size: Breakpoint): boolean {
  const breakpoints = ['xs', 'sm', 'md', 'lg']
  return breakpoints.indexOf(breakpoint) < breakpoints.indexOf(size)
}